module.exports = __webpack_public_path__ + "img/shipo-icon-barge.c2a593e7.svg";